/**
 * Returns the first button that it'll find.
 * 
 * @param {HTMLElement} element 
 * @returns HTMLButtonElement|null
 */
function buttonFinder(element) {
	let parent = element.parentElement;
	let button = parent.getElementsByTagName("BUTTON")[0];
	
	while ( typeof button === "undefined" && parent.tagName !== "BODY" ) {
		parent = parent.parentElement;
		button = parent.getElementsByTagName("BUTTON")[0];
	}
	
	return button ?? null;
}

!(function() {
	const toggleBtn = document.getElementsByClassName("toggle-answer");
	[...toggleBtn].forEach(el => {
		el.addEventListener("click", function() {
			const parent = this.parentElement
			const answerCnt = parent.getElementsByClassName("js-answer")[0];
			const button = buttonFinder(this);

			if ( button == null ) return;
			
			if ( answerCnt.offsetHeight === 0 ) {
	
				const height = answerCnt.children[0].offsetHeight;
				answerCnt.style.height = `${height}px`;
				button.innerHTML = `<svg class="w-4 mdl:w-auto" xmlns="http://www.w3.org/2000/svg" width="24" height="5" fill="currentColor" viewBox="0 0 24 5">
						<path d="M24 2.5A2.5 2.5 0 0 1 21.5 5h-19a2.5 2.5 0 0 1 0-5h19A2.5 2.5 0 0 1 24 2.5z"/>
					</svg>`;
			}
			else {
	
				answerCnt.removeAttribute("style");
				button.innerHTML = `<svg class="w-4 mdl:w-auto" xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="24" height="24" viewBox="0 0 24 24">
						<path d="M24 2.5A2.5 2.5 0 0 1 21.5 5h-19a2.5 2.5 0 0 1 0-5h19A2.5 2.5 0 0 1 24 2.5z" transform="translate(0 9.5)"/>
						<path d="M24 2.5A2.5 2.5 0 0 1 21.5 5h-19a2.5 2.5 0 0 1 0-5h19A2.5 2.5 0 0 1 24 2.5z" transform="rotate(-90 16.75 7.25)"/>
					</svg>`;
			}
		})
	});
})();